import { listItemActionRegistry } from "sulu-admin-bundle/views";

import AlertNameItemAction from "./AlertNameItemAction";

const registerListActions = () => {
    listItemActionRegistry.add("app.alert_name", AlertNameItemAction);
};

export default registerListActions;
